export default __webpack_public_path__ + "images/banner-girl-1.fdc385a6021812a51ae45713cb8c2603.png";